import {StyleSheet} from 'react-native';

const style = StyleSheet.create({
  applicationView: {
    flex: 1,
  },
});

export default style;
